<template>
  <div class="forget-pass-container">
    <RegLeftBar/>
    <div class="form-section">
      <div class="forget-pass-form">
        <h1 class="title">Forgot password</h1>
        <div class="form-input">
          <base-input
              @input="typeEmail"
              :input-type="'text'"
              :input-name="'email'"
              :label-name="'Email address'"
              :label-class="'mb-12'"
          />
        </div>
        <base-button
            class="primary"
            :loading="submitting"
            :disabled="submitting"
            @click.prevent="sendEmail"
        >
          {{ submitting ? 'Sending…' : 'Continue' }}
        </base-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import './ForgetPassword.scss'
import RegLeftBar from '@/router/components/RegLeftBar/RegLeftBar.vue';
import {useForm} from 'vee-validate';
import {object, string} from 'yup';

useForm({
  validationSchema: object({
    email: string().email().required()
  }),
})
</script>

<script>
import BaseInput from "../../UI/BaseInput";
import BaseButton from "../../UI/BaseButton";
import preloader from "@/mixins/preloader";

export default {
  name: 'ForgotPassword',
  mixins: [preloader],
  components: {
    'base-input': BaseInput,
    'base-button': BaseButton
  },
  data() {
    return {
      email: null,
      submitting: false
    }
  },
  mounted() {
    this.setLoading(false);
  },
  methods: {
    typeEmail(e) {
      this.email = e.target.value
    },
    async sendEmail() {
      if (this.submitting) return;

      this.submitting = true;
      try {
        await this.axios.get(`${process.env.VUE_APP_LIVE_URL}/sanctum/csrf-cookie`);
        const res = await this.axios.post('forgot-password', {
          email: this.email
        });
        this.toast.info(res.data.message)
        this.email = null
        await this.$router.push({name: 'email-verify'})
      } catch (error) {
        this.toast.error(error.response?.data?.message || 'Unable to send the reset email. Please try again.')
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>
